export const GET_ASSIGNED_MEMBERS = 'GET_ASSIGNED_MEMBERS'
export const GET_ASSIGNED_MEMBERS_SUCCESS = 'GET_ASSIGNED_MEMBERS_SUCCESS'
export const GET_ASSIGNED_MEMBERS_FAILURE = 'GET_ASSIGNED_MEMBERS_FAILURE'

export const CREATE_DIET_PLAN = 'CREATE_DIET_PLAN'
export const CREATE_DIET_PLAN_SUCCESS = 'CREATE_DIET_PLAN_SUCCESS'
export const CREATE_DIET_PLAN_FAILURE = 'CREATE_DIET_PLAN_FAILURE'
